export enum SignUpState {
  INITIAL = 'initial',
  SUCCESSFUL = 'successful',
  FAILED = 'failed',
  LOAD = 'load',
}
